var LAYOUT_SECONDARY = "SECONDARY";
var LAYOUT_TICKERTAPE = "TICKER_TAPE";

var _isSupportVideo = function(props) {
  return (
    (props.layout !== LAYOUT_SECONDARY && props.layout !== LAYOUT_TICKERTAPE) ||
    Number(props.forceSupportVideo) === 1
  );
};

export default { isSupportVideo: _isSupportVideo };
